import { apiFetch } from '../utils/apiClient';
import logger from '../utils/logger';
import { DATASET_CONTENTS_URL, DEFAULT_PAGE_LIMIT } from '../constants/apiEndpoints';

// ✅ MAIN FUNCTION: Fetch folder contents from backend
export const fetchDatasetContents = async (datasetId, path = '/', options = {}) => {
    const { page = 1, limit = DEFAULT_PAGE_LIMIT, search } = options;
    const offset = (page - 1) * limit;

    const url = DATASET_CONTENTS_URL(datasetId, path, limit, offset, search);

    logger.debug(`📡 Fetching folder contents:`, { datasetId, path, page, limit, offset, search });

    const data = await apiFetch(url, {
        method: 'GET'
    });

    return {
        datasetId: data.dataset_id,
        path: data.path,
        items: data.files || [],
        currentPage: data.current_page,
        totalItemsAtLevel: data.level_items_count,
        totalPagesAtLevel: data.total_pages,
        hasNextPage: data.has_next_page,
        hasPrevPage: data.has_prev_page,
        totalFilesInDataset: data.dataset_files_count,
        breadcrumb: generateBreadcrumb(data.path),
        statusCounts: data.status_counts,
        isPaginated: true
    };
};

const generateBreadcrumb = (path) => {
    const breadcrumb = [{ name: 'Dataset Root', path: '/' }];
    if (path && path !== '/') {
        const pathParts = path.substring(1).split('/').filter(Boolean);
        let currentPath = '';
        pathParts.forEach(part => {
            currentPath += '/' + part;
            breadcrumb.push({ name: part, path: currentPath });
        });
    }
    return breadcrumb;
};